import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class NewOrderService {
  public change = new BehaviorSubject(false);
  constructor() { }

}
